import React, { useEffect, useMemo, useState } from "react";
import styles from "./AllInfoMessengerContainer.module.scss";
import { useDispatch, useSelector } from "react-redux";
import Switcher from "../../ui/Switcher/Switcher";
import TelegramIcon from "../../assets/icons/TelegramIcon";
import Title from "../../ui/Title/Title";
import Select from "../../ui/Select/Select";
import Chip from "../../ui/Chip/Chip";
import Button from "../../ui/Button/Button";
import { LinkSlashIcon } from "../../assets/icons/LinkSlashIcon";
import WhatsAppIcon from "../../assets/icons/WhatsAppIcon";
import {
  setNewInst,
  setNewTg,
  setNewWa,
  setUpdateDataInst,
  setUpdateDataTg,
  setUpdateDataWa,
  setUpdateInst,
  setUpdateTg,
  setUpdateWa,
} from "../../store/slices/integrationSlice";
import { Checkbox } from "../../ui/Checkbox/Checkbox";
import { ClipLoader } from "react-spinners";
import ModalTgIntegrationForm from "../ModalTgIntegrationForm/ModalTgIntegrationForm";
import { useLocation, useNavigate } from "react-router-dom";
import { deactivateTelegram } from "../../utils/api/actions/integrations/telegram";
import {
  deactivateWhatsapp,
  getWhatsappIntegration,
} from "../../utils/api/actions/integrations/whatsapp";
import InstagramIcon from "../../assets/icons/InstagramIcon";
import ModalInstagramIntegrationForm from "../ModalInstagramIntegrationForm/ModalInstagramIntegrationForm";
import {
  deactivateInstagram,
  getInstagramIntegration,
} from "../../utils/api/actions/integrations/instagram";

export const AllInfoMessengerContainer = ({ messenger }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const externalId = location.pathname.split("/").pop();
  const id = localStorage.getItem("@storage_User_Id");

  const {
    activeTg,
    updateTg,
    newTg,
    newWa,
    activeWa,
    updateWa,
    newInst,
    activeInst,
    updateInst,
  } = useSelector((state) => state.integration);
  const { dataAssistants } = useSelector((state) => state?.assistant);

  // console.log('active INST', activeInst);
  // console.log('active WA', activeWa);
  // console.log('active TG', activeTg);

  const initialTgData = useMemo(
    () => ({
      userId: activeTg?.userId,
      clientIdentifier: activeTg?.phoneNumber,
      assistantId: activeTg?.assistantId,
      listenerActive: activeTg?.listenerActive,
    }),
    [activeTg]
  );

  const initialWaData = useMemo(
    () => ({
      userId: activeWa?.userId,
      clientIdentifier: activeWa?.phoneNumber,
      assistantId: activeWa?.assistantId,
      eventHandlerActive: activeWa?.eventHandlerActive,
    }),
    [activeWa]
  );

  const initialInstData = useMemo(
    () => ({
      userId: activeInst?.userId,
      username: activeInst?.username,
      assistantId: activeInst?.assistantId,
      directListenerActive: activeInst?.directListenerActive,
    }),
    [activeInst]
  );

  const isAssistantActive =
    messenger === "telegram"
      ? activeTg?.listenerActive
      : messenger === "whatsapp"
      ? activeWa?.eventHandlerActive
      : activeInst?.directListenerActive;

  const [isSwitchOn, setIsSwitchOn] = useState(isAssistantActive);
  const [updatedTgData, setUpdatedTgData] = useState(initialTgData);
  const [updatedWaData, setUpdatedWaData] = useState(initialWaData);
  const [updatedInstData, setUpdatedInstData] = useState(initialInstData);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Синхронизация переключателя при изменении Redux-данных
    if (messenger === "telegram" && activeTg) {
      setIsSwitchOn(activeTg.listenerActive);
    } else if (messenger === "whatsapp" && activeWa) {
      setIsSwitchOn(activeWa.eventHandlerActive);
    } else if (messenger === "instagram" && activeInst) {
      setIsSwitchOn(activeInst.directListenerActive);
    }
  }, [activeTg, activeWa, activeInst, messenger]);

  useEffect(() => {
    if (!updateTg && messenger === "telegram") {
      setUpdatedTgData(initialTgData);
      setIsSwitchOn(initialTgData.listenerActive);
    }
    if (!updateWa && messenger === "whatsapp") {
      setUpdatedWaData(initialWaData);
      setIsSwitchOn(initialWaData.eventHandlerActive);
    }
    if (!updateInst && messenger === "instagram") {
      setUpdatedInstData(initialInstData);
      setIsSwitchOn(initialInstData.directListenerActive);
    }
  }, [
    updateTg,
    updateWa,
    updateInst,
    messenger,
    initialTgData,
    initialWaData,
    initialInstData,
  ]);

  const handlerClose = () => {
    if (messenger === "telegram") {
      dispatch(setNewTg(null));
    } else if (messenger === "whatsapp") {
      dispatch(setNewWa(null));
      dispatch(getWhatsappIntegration(id, externalId));
    } else if (messenger === "instagram") {
      dispatch(setNewInst(null));
      dispatch(getInstagramIntegration(id, externalId));
    }
    setVisible(false);
  };

  const assistantName =
    dataAssistants?.find(
      (assistant) =>
        assistant.id ===
        (messenger === "telegram"
          ? updatedTgData.assistantId
          : messenger === "whatsapp"
          ? updatedWaData.assistantId
          : updatedInstData.assistantId)
    )?.name || "Ассистент не найден";

  useEffect(() => {
    setUpdatedTgData((prevData) => ({
      ...prevData,
      listenerActive: isSwitchOn,
    }));
  }, [isSwitchOn]);

  useEffect(() => {
    if (updateTg) {
      dispatch(setUpdateDataTg(updatedTgData));
    }
  }, [updateTg, updatedTgData, dispatch]);

  useEffect(() => {
    if (updateWa) {
      dispatch(setUpdateDataWa(updatedWaData));
    }
  }, [updateWa, updatedWaData, dispatch]);

  useEffect(() => {
    if (updateInst) {
      dispatch(setUpdateDataInst(updatedInstData));
    }
  }, [updateInst, updatedInstData, dispatch]);

  const DataItem = ({ title, data, chip }) => {
    return (
      <div className={styles.dataItemContainer}>
        <div className={styles.dataItemContainerFlex}>
          <label className={styles.title}>{title}</label>
          {chip && (
            <Chip
              classNameChip={styles.chipContainer}
              active={isSwitchOn}
              title={isSwitchOn ? "Активен" : "Не активен"}
            />
          )}
        </div>
        <label className={styles.data}>{data}</label>
      </div>
    );
  };

  const handleToggle = () => {
    const newSwitchState = !isSwitchOn;
    setIsSwitchOn(newSwitchState);

    if (messenger === "telegram") {
      dispatch(setUpdateTg(true));
      setUpdatedTgData((prevData) => ({
        ...prevData,
        listenerActive: newSwitchState,
      }));
    } else if (messenger === "whatsapp") {
      dispatch(setUpdateWa(true));
      setUpdatedWaData((prevData) => ({
        ...prevData,
        eventHandlerActive: newSwitchState,
      }));
    } else if (messenger === "instagram") {
      dispatch(setUpdateInst(true));
      setUpdatedInstData((prevData) => ({
        ...prevData,
        directListenerActive: newSwitchState,
      }));
    }
  };

  const selectObserver = (val) => {
    if (messenger === "telegram") {
      dispatch(setUpdateTg(true));
      setUpdatedTgData((prevData) => ({
        ...prevData,
        assistantId: val,
      }));
    } else if (messenger === "whatsapp") {
      dispatch(setUpdateWa(true));
      setUpdatedWaData((prevData) => ({
        ...prevData,
        assistantId: val,
      }));
    } else if (messenger === "instagram") {
      dispatch(setUpdateInst(true));
      setUpdatedInstData((prevData) => ({
        ...prevData,
        assistantId: val,
      }));
    }
  };

  const handleDeactivate = () => {
    localStorage.removeItem("typeTelegramInit");

    if (messenger === "telegram") {
      let data = {
        userId: activeTg.userId,
        clientIdentifier: activeTg.phoneNumber,
        withRemove: checked,
      };
      dispatch(deactivateTelegram(data, setLoading, navigate));
    } else if (messenger === "whatsapp") {
      let data = {
        userId: activeWa.userId,
        clientIdentifier: activeWa.phoneNumber,
        withRemove: true,
      };
      dispatch(deactivateWhatsapp(data, setLoading, navigate));
    } else if (messenger === "instagram") {
      let data = {
        userId: activeInst.userId,
        username: activeInst.username,
        withRemove: true,
      };
      dispatch(deactivateInstagram(data, setLoading, navigate));
    }
  };

  const isEmptyObject = (obj) => obj && Object.keys(obj).length > 0;

  useEffect(() => {
    if (isEmptyObject(newTg)) {
      setVisible(true);
    }
  }, [newTg]);

  useEffect(() => {
    if (isEmptyObject(newWa)) {
      setVisible(true);
    }
  }, [newWa]);

  useEffect(() => {
    if (isEmptyObject(newInst)) {
      setVisible(true);
    }
  }, [newInst]);

  const handleStartInit = () => {
    if (messenger === "telegram") {
      dispatch(
        setNewTg({
          userId: "",
          phone: "",
        })
      );
    } else if (messenger === "whatsapp") {
      dispatch(
        setNewWa({
          userId: "",
          phone: "",
        })
      );
    } else if (messenger === "instagram") {
      dispatch(
        setNewInst({
          userId: "",
          username: "",
        })
      );
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerInfoContainer}>
          <div className={styles.headerInfoContainerTitle}>
            <Title
              title={
                messenger === "telegram" && activeTg
                  ? activeTg?.phoneNumber
                  : messenger === "whatsapp" && activeWa
                  ? activeWa?.phoneNumber
                  : activeInst?.username
              }
              className={styles.title}
            />
            {messenger === "telegram" ? (
              <TelegramIcon />
            ) : messenger === "whatsapp" ? (
              <WhatsAppIcon size={20} fill={"#43d854"} />
            ) : (
              <InstagramIcon size={20} />
            )}
          </div>
          {(activeTg && !activeTg?.active) ||
          (activeWa && !activeWa?.active) ||
          (activeInst && !activeInst?.active) ? (
            <Button
              leftIcon={
                loading ? (
                  <ClipLoader size={20} color="white" />
                ) : (
                  <LinkSlashIcon />
                )
              }
              titleClassName={styles.buttonTitle}
              className={loading ? styles.activeButton : styles.button}
              title={loading ? "Подождите" : "Привязать"}
              onClick={handleStartInit}
            />
          ) : (
            <>
              <Button
                leftIcon={
                  loading ? (
                    <ClipLoader size={20} color="white" />
                  ) : (
                    <LinkSlashIcon />
                  )
                }
                titleClassName={styles.buttonTitle}
                className={styles.button}
                title={loading ? "Подождите" : "Отвязать"}
                onClick={handleDeactivate}
              />
              {messenger === "telegram" && (
                <Checkbox
                  value={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                />
              )}
            </>
          )}
        </div>
      </div>

      {activeTg && messenger === "telegram" && (
        <>
          <div className={styles.rowData}>
            <DataItem
              title={"Telegram id"}
              data={activeTg.externalTelegramId}
            />
            {activeTg && (
              <DataItem
                title={"Имя пользователя"}
                data={`@${activeTg.userName}`}
              />
            )}
          </div>
          {(activeTg.firstName || activeTg.lastName) && (
            <div className={styles.rowData}>
              {activeTg.firstName && (
                <DataItem title={"Имя"} data={activeTg.firstName} />
              )}
              {activeTg.lastName && (
                <DataItem title={"Фамилия"} data={activeTg.lastName} />
              )}
            </div>
          )}
        </>
      )}

      {activeWa && messenger === "whatsapp" && (
        <>
          <div className={styles.rowData}>
            <DataItem
              title={"WhatsApp id"}
              data={activeWa.externalWhatsappId}
            />
          </div>
        </>
      )}

      {activeInst && messenger === "instagram" && (
        <>
          <div className={styles.rowData}>
            <DataItem
              title={"Instagram id"}
              data={activeInst.externalInstagramId}
            />
            {activeInst?.fullname !== "" && (
              <DataItem title={"Имя"} data={activeInst?.fullName} />
            )}
            {activeInst?.username !== "" && (
              <DataItem title={"Никнейм"} data={`@${activeInst?.username}`} />
            )}
          </div>
        </>
      )}

      <div className={styles.headerAssistantContainer}>
        <DataItem
          title={`Ассистент`}
          chip={true}
          data={
            <Select
              containerStyle={styles.containerSelect}
              labelStyle={styles.labelSelect}
              dataSelect={dataAssistants}
              selectObserver={selectObserver}
              nameSelectedOption={assistantName}
              activeTg={activeTg?.active}
              activeWa={activeWa?.active}
              activeInst={activeInst?.active}
              messenger={messenger}
            />
          }
        />
        <div>
          <DataItem
            title={"Статус"}
            data={
              <Switcher
                switchStyle={styles.switchContainer}
                bool={isSwitchOn}
                onToggle={handleToggle}
                disabled={
                  (messenger === "telegram" && !activeTg?.active) ||
                  (messenger === "whatsapp" && !activeWa?.active) ||
                  (messenger === "instagram" && !activeInst?.active)
                }
              />
            }
          />
        </div>
      </div>
      {newTg && (
        <ModalTgIntegrationForm visible={visible} handlerClose={handlerClose} />
      )}
      {newInst && (
        <ModalInstagramIntegrationForm
          visible={visible}
          handlerClose={handlerClose}
        />
      )}
    </div>
  );
};
